/**
 * @file useHistoryTimeline.js
 * @description 공개 페이지에서 연혁을 조회하고 응답 전이나 실패 시 폴백을 유지합니다.
 * @used-in pages/company/CompanyAboutPage.jsx, pages/company/CompanyHistoryPage.jsx
 */

import { useEffect, useState } from 'react';
import { fetchHistory } from '../services/adminApi';

const EMPTY_TIMELINE = [];

// [기능] 연혁을 한 번 조회해 목록과 로딩 상태를 반환합니다.
export function useHistoryTimeline(fallbackItems = EMPTY_TIMELINE) {
  const [items, setItems] = useState(() => fallbackItems);
  const [loading, setLoading] = useState(true);

  // [기능] 마운트 시 연혁을 조회하고 언마운트 이후 상태 갱신을 막습니다.
  useEffect(() => {
    let isActive = true;

    // [기능] 유효한 연혁 응답을 반영하고 성공 여부와 관계없이 로딩을 마칩니다.
    async function loadHistory() {
      try {
        const historyItems = await fetchHistory();
        // [기술] 서버 오류 시 { message } 객체가 올 수 있고, 배열이 아닌 값을 그대로 렌더하면 페이지가 깨집니다.
        if (isActive && Array.isArray(historyItems)) {
          setItems(historyItems);
        }
      } catch {
        // [비즈니스] 연혁을 불러오지 못해도 공개 페이지에는 빌드 시점의 연혁이 그대로 보여야 하므로, 실패 시 폴백을 유지합니다.
      } finally {
        if (isActive) setLoading(false);
      }
    }

    loadHistory();

    // [기능] 언마운트된 페이지로 조회 결과가 전달되지 않도록 합니다.
    return () => {
      isActive = false;
    };
  }, []);

  return { items, loading };
}
